/**
 *
 * SetPassword
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"
import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import { Input, Button } from "antd"
import { Link } from "react-router-dom"
import Loader from "components/Loader"
import reducer from "./reducer"
import saga from "./saga"
import "./index.less"
import { CheckOutlined } from "@ant-design/icons"

import {
  makeSelectValidateCode,
  makeSelectIsLoadingValidateCode,
  makeSelectSetPassCorrect,
  makeSelectIsLoadingSetPassCorrect,
} from "./selectors"
import { validateUserWatcher, setPasswordWatcher } from "./actions"
import { validatePassword } from "../../utils/passwordRules"

import logoImage from "images/brand/Mandu_white.svg"
import worldImage from "../../images/Planeta.svg"
import PageLogo from "../../components/PageLogo"
import { loadTextsLocalStorage } from "../../utils/i18n"
import { LanguageSelector } from "../../components/LanguageSelector"
import { LOCAL_LOGIN_LANGUAGE } from "../../utils/storage"

/* eslint-disable react/prefer-stateless-function */
export class SetPassword extends React.Component {
  state = {
    password: undefined,
    password_confirmation: undefined,
    password_validation: false,
  }

  intl = loadTextsLocalStorage("login")

  componentDidMount = () => {
    const {
      match: { params },
    } = this.props

    this.props.validateUserWatcher(params)
  }

  sendToServer = () => {
    const {
      match: { params },
    } = this.props
    const { password, password_confirmation } = this.state

    const data = {
      ...params,
      password,
      password_confirmation,
      loginLanguage: LOCAL_LOGIN_LANGUAGE()
    }

    this.props.setPasswordWatcher(data)
  }

  changePasswordValue(e) {
    this.setState({ password: e.target.value })

    let { passedRules, status } = validatePassword(e.target.value)

    let rulesElements = document.querySelectorAll(".password-rules-list li")
    rulesElements.forEach((ruleElement) =>
      ruleElement.classList.remove("active")
    )

    passedRules.forEach((rule) => {
      document.getElementById(rule).classList.add("active")
    })

    this.setState({ password_validation: status })
  }

  changePasswordConfirmationValue(e) {
    this.setState({ password_confirmation: e.target.value })
  }

  samePasswordInput() {
    return this.state.password === this.state.password_confirmation
  }

  ruleIcon = () => {
    return (
      <>
        <svg
          className="wrong"
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <circle
            opacity="0.7"
            cx="5"
            cy="5"
            r="4.25"
            stroke="white"
            strokeWidth="1.5"
          />
        </svg>
        <CheckOutlined className="check" style={{ color: "#89e771" }} />
      </>
    )
  }

  renderForm = () => {
    return (
      <React.Fragment>
        <h1>{this.intl.resetPasswordForm.title}</h1>
        <div className="container-restpassword__actions">
          <Input
            placeholder={this.intl.resetPasswordForm.password}
            className="container-restpassword__input"
            type="password"
            value={this.state.password}
            onChange={(e) => this.changePasswordValue(e)}
          />
          <Input
            placeholder={this.intl.resetPasswordForm.confirmPassword}
            className="container-restpassword__input"
            type="password"
            value={this.state.password_confirmation}
            onChange={(e) => this.changePasswordConfirmationValue(e)}
          />
          <div className="container-setpassword__rules">
            <ul className="password-rules-list">
              <li id="min-characters">
                {this.ruleIcon()}
                {this.intl.resetPasswordForm.ruleCharacters}
              </li>
              <li id="at-least-one-number">
                {this.ruleIcon()}
                {this.intl.resetPasswordForm.ruleNumber}
              </li>
              <li id="upper-and-lower">
                {this.ruleIcon()}
                {this.intl.resetPasswordForm.ruleUppercaseAndLowercase}
              </li>
              <li id="at-least-one-special-character">
                {this.ruleIcon()}
                {this.intl.resetPasswordForm.ruleSpecialCharacter}
              </li>
            </ul>
          </div>
          <Button
            disabled={
              !this.state.password_confirmation ||
              !this.state.password ||
              !this.state.password_validation
            }
            className="container-restpassword__button"
            onClick={this.sendToServer}
            loading={this.props.isLoadingSetPassCorrect}>
            {this.intl.resetPasswordForm.accept}
          </Button>
        </div>
      </React.Fragment>
    )
  }

  renderConfirm = () => {
    return (
      <React.Fragment>
        <h1>{this.intl.finishResetPasswordForm.title}</h1>
        <p
          className="container-restpassword__description"
          style={{ marginTop: 32, maxWidth: 470 }}>
          {this.intl.finishResetPasswordForm.description}
        </p>
        <p className="container-restpassword__footer">
        {this.intl.finishResetPasswordForm.message}<span>support.peru@visma.com</span>.
        </p>
      </React.Fragment>
    )
  }

  render() {
    if (this.props.isLoadingValidateCode) return <Loader />

    if (this.props.validateCode == 404) {
      return (
        <div className="container-restpassword__no-found">
          <img src={worldImage} />
          <span>¡Ooops!</span>
          <p>Este enlace ya no se encuentra vigente.</p>
          <div>
            Para solicitar un nuevo link de restablecimiento de contraseña a tu
            correo, <Link to="/forgottenPassword">haz click aquí.</Link>
          </div>
        </div>
      )
    }

    return (
      <PageLogo>
        <LanguageSelector/>
        <div className="container-restpassword">
          <img src={logoImage} />
          {this.props.setPassCorrect ? this.renderConfirm() : this.renderForm()}
        </div>
      </PageLogo>
    )
  }
}

SetPassword.propTypes = {
  // dispatch: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  validateCode: makeSelectValidateCode(),
  isLoadingValidateCode: makeSelectIsLoadingValidateCode(),
  setPassCorrect: makeSelectSetPassCorrect(),
  isLoadingSetPassCorrect: makeSelectIsLoadingSetPassCorrect(),
})

function mapDispatchToProps(dispatch) {
  return {
    validateUserWatcher: (params) => dispatch(validateUserWatcher(params)),
    setPasswordWatcher: (params) => dispatch(setPasswordWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "setPassword", reducer })
const withSaga = injectSaga({ key: "setPassword", saga })

export default compose(withReducer, withSaga, withConnect)(SetPassword)
